
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { GiSplitCross } from "react-icons/gi";
import { FaPlus, FaMinus } from "react-icons/fa";
import { updateItem } from "./api";

const UpdateItemForm = ({ itemId, onUpdate }) => {
  const { id } = useParams();
  const [showForm,setShowForm] =useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    itemName: "",
    grossWeight: "",
    goldRate: "",
    netGoldWeight: "",
   
    diamondType: [{ type: "", weight: "", rate: "" }],
    stoneType: [{ type: "", weight: "", rate: "" }],
    laborCharge: "",
    totalRate: "",
    image: null,
    image2: null,
    video: null,
    category: "",
    caratTypes:"",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [imagePreviews, setImagePreviews] = useState([]);
  const [videoPreview, setVideoPreview] = useState("");

  useEffect(() => {
    // Fetch existing item data for the given itemId
    const fetchItemData = async () => {
      try {
        setLoading(true);

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}item/items/${id}`
        );
        const itemDetails = response.data.data;
        console.log(itemDetails, "update item data");
        setFormData({
          itemName: itemDetails.itemName || "",
          grossWeight: itemDetails.grossWeight || "",
          goldRate: itemDetails.goldRate || "",
          netGoldWeight: itemDetails.netGoldWeight || "",
          roundDiamondWeight: itemDetails.roundDiamondWeight || "",
          roundDiamondRate: itemDetails.roundDiamondRate || "",
          polkiDiamondWeight: itemDetails.polkiDiamondWeight || "",
          polkiDiamondRate: itemDetails.polkiDiamondRate || "",
          diamondType: itemDetails.diamondType || [
            { type: "", weight: "", rate: "" },
          ],
          stoneType: itemDetails.stoneType || [
            { type: "", weight: "", rate: "" },
          ],
          laborCharge: itemDetails.laborCharge || "",
          totalRate: itemDetails.totalRate || "",
          category: itemDetails.category || "",
          caratTypes: itemDetails.caratTypes || "",
          image: itemDetails.image || null,
          image2: itemDetails.image2 || null,
          video: itemDetails.video || null,
        });
        setLoading(false);

        // Set initial previews if URLs are present
        if (itemDetails.image) setImagePreviews([itemDetails.image]);
        if (itemDetails.image2)
          setImagePreviews((prev) => [...prev, itemDetails.image2]);
        if (itemDetails.video) setVideoPreview(itemDetails.video);
      } catch (error) {
        setError("Failed to load item data");
        setLoading(false);
      }
    };
    fetchItemData();
  }, [id]);

  const handleStoneChange = (index, e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newStones = [...prevFormData.stoneType];
      newStones[index][name] = value;
      return { ...prevFormData, stoneType: newStones };
    });
  };
  const handleDiamondChange = (index, e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newDiamonds = [...prevFormData.diamondType];
      newDiamonds[index][name] = value;
      return { ...prevFormData, diamondType: newDiamonds };
    });
  };

  const addStone = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      stoneType: [
        ...prevFormData.stoneType,
        { type: "", weight: "", rate: "" },
      ],
    }));
  };
  const addDiamond = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      diamondType: [
        ...prevFormData.diamondType,
        { type: "", weight: "", rate: "" },
      ],
    }));
  };

  const removeStone = (index) => {
    setFormData((prevFormData) => {
      const newStones = [...prevFormData.stoneType];
      newStones.splice(index, 1);
      return { ...prevFormData, stoneType: newStones };
    });
  };
  const removeDiamond = (index) => {
    setFormData((prevFormData) => {
      const newDiamonds = [...prevFormData.diamondType];
      newDiamonds.splice(index, 1);
      return { ...prevFormData, diamondType: newDiamonds };
    });
  };
  const handleCancel = () => {
    setShowForm(false);
    navigate(-1);
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      const file = files[0];
      if (name === "image" || name === "image2") {
        setFormData({
          ...formData,
          [name]: file,
        });
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreviews((prev) => [...prev, reader.result]);
        };
        reader.readAsDataURL(file);
      } else if (name === "video") {
        setFormData({
          ...formData,
          [name]: file,
        });
        const reader = new FileReader();
        reader.onloadend = () => {
          setVideoPreview(reader.result);
        };
        reader.readAsDataURL(file);
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const formDataSend = new FormData();
      formDataSend.append("itemName", formData.itemName || "");
      formDataSend.append("grossWeight", formData.grossWeight || "");
      formDataSend.append("goldRate", formData.goldRate || "");
      formDataSend.append("netGoldWeight", formData.netGoldWeight || "");
     
      formDataSend.append("laborCharge", formData.laborCharge || "");
      formDataSend.append("totalRate", formData.totalRate || "");
      formDataSend.append("category", formData.category || "");
      formDataSend.append("caratTypes", formData.caratTypes || "");
      formDataSend.append(
        "stoneType",
        JSON.stringify(formData.stoneType || [])
      );
      formDataSend.append(
        "diamondType",
        JSON.stringify(formData.diamondType || [])
      );
      if (formData.image) {
        formDataSend.append("image", formData.image);
      }
      if (formData.image2) {
        formDataSend.append("image2", formData.image2);
      }
      if (formData.video) {
        formDataSend.append("video", formData.video);
      }
        
      const response = await updateItem(id, formDataSend);

      toast.success("Item updated successfully");
      setShowForm(false);
   // Trigger parent callback to refresh the item list
      setLoading(false);
      navigate(-1);
    } catch (error) {
      setError("Failed to update item. Please check the inputs and try again.");
      setLoading(false);
    }
  };

  return loading ? (
    <div className="fixed top-0 mt-20 left-0 w-full h-full flex items-center justify-center bg-white bg-opacity-80 z-50">
      <div className="flex flex-col items-center gap-2">
        <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-green-600"></div>
        <h1 className="text-xl text-green-600 font-medium">Please Wait...</h1>
      </div>
    </div>
  ) : (
    <form
      className="bg-white shadow-md rounded-lg p-4  md:pt-[100px] pt-[100px] w-full lg:px-5 mx-auto z-30"
      onSubmit={handleSubmit}
    >
      <div className="flex justify-between w-full items-center">
        <h2 className="text-lg font-bold mb-4">Update Item</h2>
        <GiSplitCross
          onClick={handleCancel}
          className="text-lg font-bold mb-4 cursor-pointer"
        />
      </div>
      {error && <div className="text-red-500 mb-4">{error}</div>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-gray-700 capitalize">Item Name</label>
          <input
            type="text"
            name="itemName"
            value={formData.itemName}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg"
            placeholder="Enter item name"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 capitalize">Category</label>
          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg"
            required
          >
            <option value="">Select Category</option>
            <option value="EarRing">Ear Ring</option>
            <option value="Necklace">Necklace</option>
            <option value="Ring">Ring</option>
          </select>
        </div>
      </div>

      {/* Gold Section */}
      <div className="mt-6">
        <h3 className="text-xl font-semibold mb-3">Gold Details</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
         
          <div>
            <label className="block text-gray-700 capitalize">
              Gold Rate (per gm)
            </label>
            <input
              type="number"
              name="goldRate"
              value={formData.goldRate}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter gold rate"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 capitalize">
              Net Gold Weight (in gms)
            </label>
            <input
              type="number"
              name="netGoldWeight"
              value={formData.netGoldWeight}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter net gold weight"
              required
            />
          </div>
          <div>
          <label className="block text-gray-700 capitalize">Gold Purity</label>
          <select
            name="caratTypes"
            value={formData.caratTypes}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg"
            required
          >
            <option value="">Select</option>
            <option value="16">16 carat</option>
            <option value="18">18 carat</option>
            <option value="20">20 carat</option>
            <option value="22">22 carat</option>
            <option value="24">24 carat</option>
          </select>
        </div>
        </div>
      </div>

      {/* Diamond Section */}
      {/* <div className="mt-6">
        <h3 className="text-xl font-semibold mb-3">Diamond Details</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-gray-700 capitalize">
              Round Diamond Weight (in cts)
            </label>
            <input
              type="number"
              name="roundDiamondWeight"
              value={formData.roundDiamondWeight}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter round diamond weight"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 capitalize">
              Round Diamond Rate (per ct)
            </label>
            <input
              type="number"
              name="roundDiamondRate"
              value={formData.roundDiamondRate}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter round diamond rate"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 capitalize">
              Polki Diamond Weight (in cts)
            </label>
            <input
              type="number"
              name="polkiDiamondWeight"
              value={formData.polkiDiamondWeight}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter polki diamond weight"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 capitalize">
              Polki Diamond Rate (per ct)
            </label>
            <input
              type="number"
              name="polkiDiamondRate"
              value={formData.polkiDiamondRate}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter polki diamond rate"
              required
            />
          </div>
        </div>
      </div> */}
     {/* <div className="mt-6">
        <h3 className="text-xl font-semibold mb-3">Stone Details</h3>
        {formData.diamondType.map((diamond, index) => (
          <div key={index} className="flex flex-col md:flex-row gap-4 mb-4">
            <div className="flex-1">
              <label className="block text-gray-700 capitalize">
              Diamond Type
              </label>
              <input
                type="text"
                name="type"
                value={diamond.type}
                onChange={(e) => handleDiamondChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter stone type"
                required
              />
            </div>
            <div className="flex-1">
              <label className="block text-gray-700 capitalize">
                Weight (in cts)
              </label>
              <input
                type="number"
                name="weight"
                value={diamond.weight}
                onChange={(e) => handleDiamondChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter weight"
                required
              />
            </div>
            <div className="flex-1">
              <label className="block text-gray-700 capitalize">
                Rate (per ct)
              </label>
              <input
                type="number"
                name="rate"
                value={diamond.rate}
                onChange={(e) => handleDiamondChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter rate"
                required
              />
            </div>
            <button
                type="button"
                onClick={() => removeDiamond(index)}
                className="ml-3 md:w-[3vh] w-[25px] mt-5 bg-red-500 text-white p-1 rounded-lg"
              >
                <FaMinus />
              </button>
          </div>
        ))}
        <button
          type="button"
          onClick={addDiamond}
          className="flex p-4 items-center text-lg justify-center bg-green-500 text-white  rounded-lg hover:bg-green-600"
        >
          <FaPlus className="mr-2" /> Add Diamond
        </button>
      </div> */}

      {/* Stone Section */}
      {/* <div className="mt-6">
        <h3 className="text-xl font-semibold mb-3">Stone Details</h3>
        {formData.stoneType.map((stone, index) => (
          <div key={index} className="flex flex-col md:flex-row gap-4 mb-4">
            <div className="flex-1">
              <label className="block text-gray-700 capitalize">
                Stone Type
              </label>
              <input
                type="text"
                name="type"
                value={stone.type}
                onChange={(e) => handleStoneChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter stone type"
                required
              />
            </div>
            <div className="flex-1">
              <label className="block text-gray-700 capitalize">
                Weight (in cts)
              </label>
              <input
                type="number"
                name="weight"
                value={stone.weight}
                onChange={(e) => handleStoneChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter weight"
                required
              />
            </div>
            <div className="flex-1">
              <label className="block text-gray-700 capitalize">
                Rate (per ct)
              </label>
              <input
                type="number"
                name="rate"
                value={stone.rate}
                onChange={(e) => handleStoneChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter rate"
                required
              />
            </div>
            <button
                type="button"
                onClick={() => removeStone(index)}
                className="ml-3 md:w-[3vh] w-[25px] mt-5 bg-red-500 text-white p-1 rounded-lg"
              >
                <FaMinus />
              </button>
          </div>
        ))}
        <button
          type="button"
          onClick={addStone}

          className="flex p-4 items-center text-lg justify-center bg-green-500 text-white  rounded-lg hover:bg-green-600"
        >
          <FaPlus className="mr-2" /> Add Stone
        </button>
      </div> */}
 <div className="mt-6">
        <h3 className="text-xl font-semibold mb-3">Diamond Details</h3>
        {formData.diamondType.map((diamond, index) => (
          <div
            key={index}
            className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3"
          >
            <div>
              <label className="block text-gray-700 capitalize">Type  <span className=" text-xl text-red-700">*</span></label>
              <input
                type="text"
                name="type"
                value={diamond.type}
                onChange={(e) => handleDiamondChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter stone type"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 capitalize">Weight <span>(in carat) </span><span className=" text-xl text-red-700">*</span></label>
              <input
                type="number"
                name="weight"
                value={diamond.weight}
                onChange={(e) => handleDiamondChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter stone weight"
                step="0.01"
                min="0"
                required
              />
            </div>
         
            <div className="flex items-center ">
             <div className=" flex w-full flex-col items-start justify-start">
             <label className="block text-gray-700  capitalize">Rate  <span className=" text-xl text-red-700">*</span></label>
              <input
                type="number"
                name="rate"
                value={diamond.rate}
                onChange={(e) => handleDiamondChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter stone rate"
                step="0.01"
                min="0"
                required
              />
             </div>
              <button
                type="button"
                onClick={() => removeDiamond(index)}
                className="ml-3 md:w-[3vh] w-[25px] mt-5 bg-red-500 text-white p-1 rounded-lg"
              >
                <FaMinus />
              </button>
            </div>
          </div>
        ))}
        <button
          type="button"
          onClick={addDiamond}
          className="bg-blue-500 text-white p-2 rounded-lg mt-4"
        >
         <div className=" flex items-center justify-center p-1 gap-2 text-lg"> <FaPlus /> Add Diamond</div>
        </button>
      </div>
      {/* Stone Section */}
      <div className="mt-6">
        <h3 className="text-xl font-semibold mb-3">Stone Details</h3>
        {formData.stoneType.map((stone, index) => (
          <div
            key={index}
            className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3"
          >
            <div>
              <label className="block text-gray-700 capitalize">Type  <span className=" text-xl text-red-700">*</span></label>
              <input
                type="text"
                name="type"
                value={stone.type}
                onChange={(e) => handleStoneChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter stone type"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 capitalize">Weight  <span>(in carat) </span> <span className=" text-xl text-red-700">*</span></label>
              <input
                type="number"
                name="weight"
                value={stone.weight}
                onChange={(e) => handleStoneChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter stone weight"
                step="0.01"
                min="0"
                required
              />
            </div>
            <div className="flex items-center ">
             <div className=" flex w-full flex-col items-start justify-start">
             <label className="block text-gray-700  capitalize">Rate  <span className=" text-xl text-red-700">*</span></label>
              <input
                type="number"
                name="rate"
                value={stone.rate}
                onChange={(e) => handleStoneChange(index, e)}
                className="w-full p-2 border border-gray-300 rounded-lg"
                placeholder="Enter stone rate"
                step="0.01"
                min="0"
                required
              />
             </div>
              <button
                type="button"
                onClick={() => removeStone(index)}
                className="ml-3 md:w-[3vh] w-[25px] mt-5 bg-red-500 text-white p-1 rounded-lg"
              >
                <FaMinus />
              </button>
            </div>
          </div>
        ))}
         <button
          type="button"
          onClick={addStone}
          className="bg-blue-500 p-2 text-white rounded-lg mt-4"
        >
         <div className=" flex items-center justify-center p-1 gap-2 text-lg"> <FaPlus /> Add Stone</div>
        </button>
      </div>
      {/* Labor Charges and Total Rate */}
      <div className="mt-6">
        <h3 className="text-xl font-semibold mb-3">Additional Details</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-gray-700 capitalize">
              Labor Charge
            </label>
            <input
              type="number"
              name="laborCharge"
              value={formData.laborCharge}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter labor charge"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 capitalize">
              Gross Weight (in gms)
            </label>
            <input
              type="number"
              name="grossWeight"
              value={formData.grossWeight}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter gross weight"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 capitalize">Total Rate</label>
            <input
              type="number"
              name="totalRate"
              value={formData.totalRate}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholder="Enter total rate"
              required
            />
          </div>
        </div>
      </div>

      {/* Image and Video Upload */}
      <div className="mt-6">
        <h3 className="text-xl font-semibold mb-3">Upload Images and Video</h3>
        <div className="flex flex-col gap-4">
          <div>
            <label className="block text-gray-700 capitalize">
              Upload Image 1
            </label>
            <input
              type="file"
              name="image"
              accept="image/*"
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
            />
            {imagePreviews.length > 0 && (
              <div className="mt-2">
                
                  <img
            
                    src={imagePreviews[0]}
                    height={50}
                    width={50}
                    alt={`Preview 1`}
                    className="w-[150px] h-[150px] object-cover border border-gray-300 rounded-lg"
                  />
               
              </div>
            )}
          </div>
          <div>
            <label className="block text-gray-700 capitalize">
              Upload Image 2
            </label>
            <input
              type="file"
              name="image2"
              accept="image/*"
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
            />
            {imagePreviews.length > 1 && (
              <div className="mt-2">
                
                  <img
            
                    src={imagePreviews[1]}
                    height={50}
                    width={50}
                    alt={`Preview 1`}
                    className="w-[150px] h-[150px] object-cover border border-gray-300 rounded-lg"
                  />
               
              </div>
            )}
          </div>
        
          <div>
            <label className="block text-gray-700 capitalize">
              Upload Video
            </label>
            <input
              type="file"
              name="video"
              accept="video/*"
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg"
            />
            {videoPreview && (
              <div className="mt-2">
                <video
                  controls
                  src={videoPreview}
                  className="w-[150px] h-[150px] border border-gray-300 rounded-lg"
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <div className="mt-6">
        <button
          type="submit"
          className="bg-blue-500 text-white p-2 rounded-lg hover:bg-blue-600"
        >
          Update Item
        </button>
      </div>
    </form>
  );
};

export default UpdateItemForm;
